import { Row } from "react-bootstrap";
import { ReactComponent as OutlineCopy } from "assets/svg/outline-copy.svg";
import { ReactComponent as Separator } from "assets/svg/line-3.svg";
import IconButton from "components/icon-button";
import ToggleSwitch from "components/toggle-switch";
import Delete from "./components/delete";

import styles from "./styles.module.scss";
import type { DndItemProp } from "../../../../types";

type Props = {
  id: string;
  className: string;
  uiSchema: UISchema;
  jsonSchema: JSONSchema;
  required?: boolean;
  isSection?: boolean;

  onAddSibling?: (arg: DndItemProp, dropId: string, after: boolean) => void;
  onRemoveFromParent?: (arg: string) => void;
  onRequiredChange?: (arg: boolean) => void;
};

const Actions = ({
  id,
  className,
  jsonSchema,
  uiSchema,
  required,
  isSection,
  onAddSibling,
  onRemoveFromParent,
  onRequiredChange,
}: Props) => {
  return (
    <Row
      className={styles["actions"] + " " + className}
      // need for safari
      tabIndex={0}
    >
      <IconButton
        className={styles["actions__copy"]}
        onClick={() =>
          onAddSibling &&
          onAddSibling(
            {
              id: `${id}-${+new Date()}-copy`,
              jsonSchema: JSON.parse(JSON.stringify(jsonSchema)),
              uiSchema: JSON.parse(JSON.stringify(uiSchema)),
              required,
            },
            id,
            true,
          )
        }
      >
        <OutlineCopy />
      </IconButton>
      <Delete
        onDelete={() => onRemoveFromParent && onRemoveFromParent(id)}
        isSection={isSection}
      />
      {jsonSchema.type !== "object" && (
        <>
          <Separator className="mx-2" color={`var(--gray02)`} />
          <div className="d-flex ml-2 align-items-center">
            <div className="mr-3">Require answer</div>
            <ToggleSwitch
              checked={required}
              onChange={(e) =>
                onRequiredChange && onRequiredChange(e.target.checked)
              }
            />
          </div>
        </>
      )}
    </Row>
  );
};

export default Actions;
